import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

// URL base de la API
// const API_URL = getApiBaseUrl();
const API_URL = getApiBaseUrl();

//// Crear una instancia de Axios
const api = axios.create({
  baseURL: API_URL,
});

// Configurar un interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
  (config) => {
    // Obtener el token del localStorage
    const token = secureStorage.getItem('authToken');
    
    if (token) {
      // Agregar el token al encabezado de autorización
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const getDatosProducto = async (codigo) => {
  try {
    const response = await api.get('productos',{ params: { codigo } });
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getDatosCategoria= async () => {
  try {
    const response = await api.get('categorias');
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};


const getOneDatosCargadoraCab = async (id) => {
  try {
    const response = await api.get(`cargadoraCabSerie/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const PostDatosProductos = async (datos) => {
  try {
    const response = await api.post('productos', datos);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error('Error al enviar datos al backend: ' + error.response.data.message);
    } else {
      throw new Error('Error al enviar datos al backend: ' + error.message);
    }
  }
};

const updateChapaDesc= async (orden, data) => {
  try {

    const response = await api.put(`${API_URL}updateOrdenCantidad/${orden}`, data);
    return response.data;
  } catch (error) {
    throw new Error('Error al Actualizar los Datos: ', error.message);
  }
};


const getOnePaquetexd = async (serie) => {
  try {
    const response = await api.get(`getOnePaquetexd/${serie}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};


const getVaciarChapa = async (orden) => {
  try {
    const response = await api.get(`vaciarReservas/${orden}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener datos del backend:', error);
  }
};

const getCargadoraCabPaquete = async (id) => {
  try {
    const response = await api.get(`cargadoraCabPaquete/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener paquetes del caballete:', error);
  }
};

export { getDatosProducto, updateChapaDesc,getOnePaquetexd, getOneDatosCargadoraCab, getDatosCategoria, PostDatosProductos, getVaciarChapa, getCargadoraCabPaquete };
